import * as React from "react";
import FieldWrapper, { ComponentProps, GenericDropdown } from "../FieldWrapper";
import { SettingPrefixEnum, SettingEnum } from "../settingEnum";
import { LabelEnum } from "../../LabelEnum";
import { connect } from "react-redux";
import { FirmwareForDevice } from "../../Store/types";
import { useIntl } from "react-intl";
import { AppState } from "@Safemate/Store/types";

interface SelectFirmwareProps{
    firmware: FirmwareForDevice;
    climaxFirmwareAdmin: boolean;
    selectedDeviceHardwareId: number;
}

const mapStateToProps = ({ appData: { climaxFirmwareAdmin }, defaultSettings: {firmware: { firmware }, deviceHardware: { selectedDeviceHardwareId }}}: AppState) => {
    return{
        firmware,
        climaxFirmwareAdmin,
        selectedDeviceHardwareId
    }
  };

export const SelectFirmware = connect(mapStateToProps)(({ firmware, climaxFirmwareAdmin, selectedDeviceHardwareId }: SelectFirmwareProps) => {

    const { formatMessage } = useIntl();

    const mappedOptions = React.useMemo(() => {
        if(firmware[selectedDeviceHardwareId]){
            const opts: {text: string, value: number | null}[] = firmware[selectedDeviceHardwareId].map((f) => {
                return {
                    text: f.name,
                    value: f.fiwaNum
                }
            })
            opts.unshift({text: formatMessage({id: "defaultFirmware", defaultMessage: "Ingen overstyring"}), value: null});
            return opts;
        }
        return [];
    }, [firmware, selectedDeviceHardwareId]);

    if(!climaxFirmwareAdmin) return null;

    return React.createElement(FieldWrapper({
        componentOptions: {
          Component: GenericDropdown,
          props: {}
        },
        prefix: SettingPrefixEnum.DEVICE_SETTING,
        policyPrefix: SettingPrefixEnum.FIRMWARE,
        field: SettingEnum.FIRMWARE,
        title: LabelEnum.SELECT_FIRMWARE,
        tooltip: LabelEnum.SELECT_FIRMWARE_TOOLTIP,
        dataOptions: {
          options: mappedOptions,
          skipMap: true
        }
      }))
}) as React.FunctionComponent<ComponentProps>

